import React, { useEffect, useState, useRef } from "react";
import { Table, Input } from "antd";
import { getGcaApplications } from "../auth/services/privateapicalling";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { label } from "yet-another-react-lightbox/*";
import CommonSelect from "../pages/license-registration-form/CommonSelect";
import CommonStatusSelect from "../application/CommonSelect";
import { Option } from "../application/CommonSelect";

interface StatusProp {
  status: any[];
  
}



const ApplicationTable: React.FC<StatusProp> = ({ status }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [Selections, setSelections] = useState<boolean>(true);
  const [applicationData, setApplicationData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5); // Default limit
  const [totalItems, setTotalItems] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
  
  // const statusOptions = [
  //   {value: "all" , label:"All"},
  //   { value: "pendingAtClerk", label: "Pending At Clerk" },
  //   { value: "pendingAtCo", label: "Pending At Co" },
  //   { value: "pendingAtClerkResubmission", label: "Pending At Clerk Resubmission" },
  //   { value: "pendingAtCoResubmission", label: "Pending At Co Resubmission" },
  //   { value: "pendingAtDr", label: "Pending At Dr" },
  //   { value: "pendingAtDrResubmission", label: "Pending At Dr Resubmission" },
    
  // ];
  const EntityOptions = [
    { value: "Ind", label: "Individual" },
    { value: "Firm", label: "Firm" },
    { value: "Company", label: "Company" },
    { value: "CoSciety", label: "Cooperative Society" },
    { value: "Fpo", label: "Farmer Producer Organization (FPO)" },
    { value: "govEnt", label: "Government Entity" },
    { value: "Ngo", label: "Non-Governmental Organization (NGO)" },
    { value: "partnerFirm", label: "Partnership Firm" },
    { value: "Llp", label: "Limited Liability Partnership (LLP)" },
    { value: "Trust", label: "Trust" },
    { value: "Jv", label: "Joint Venture" },
  ]; 

  const [selectedStatus, setSelectedStatus] = useState<Option | null>(status[0]);
const language = useSelector((state:any)=>state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const navigate = useNavigate();
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const onSelectChange = (newSelectedRowKeys: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const columns = [
    {
      title: language.application_id,
      dataIndex: "applicationId",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
    { title: language.agentName, dataIndex: "applicantName" },
    { title: language.applicant_type, dataIndex: "entityType",
      render: (text: string) => (
        <h6 className="fw-medium">
           {EntityOptions.find((_item) => _item.value === text)?.label || "N/A"}
        </h6>
      ),
     },
      {
      title: "License Type",
      dataIndex: "licenseType",
      render: (text: string, record: any) => {
        // Append year if licenseType is 1 or 3 and year is present
    
        return text+" "+"year";
      }
    },
    { title: language.apmc, dataIndex: "apmc" },
    {
      title: language.applied_date,
      dataIndex: "appliedDate",
      render: (date: string) => new Date(date).toLocaleDateString("en-GB"), // "DD/MM/YY"
    },
    {
      title: language.application_status,
      dataIndex: "status",
      render: (status: string) => {
        const statusMapping: Record<string, string> = {
              permanentReject: "Permanent reject by Department",
          approvedUnsigned: "Approve Unsigned",
          approve:"Approved by Department",
          reject: "Raised Query by Department",
          pending:"Review under Department",
          resubmission: "Resubmission",
          draft:"Draft"


        };

        return <span>{statusMapping[status] || status}</span>;
      },
    },
    {
      title: language.action,
      dataIndex: "applicationId",
      render: (text: string, record: any) =>
        record.action ? ( // Only show button if record.action is true
          <h6 className="fw-medium">
            <button
              className="bg-info rounded text-white px-4 py-2"
              onClick={() =>
                navigate("/gca-application-preview", {
                  state: { applicationId: record.applicationId },
                })
              }
            >
              {language.review}
            </button>
          </h6>
        ) : ( 
        <h6 className="fw-medium">
          <button
            className="bg-primary rounded text-white px-4 py-2"
            onClick={() =>
              navigate("/gca-application-preview", {
                state: { applicationId: record.applicationId },
              })
            }
          >
            {language.view}
          </button>
        </h6>), 
    }
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  const fetchApplication = async (
    page: number,
    searchApplicationById: string = "",
    limit: number,
    status?: string
  ) => {
    setLoading(true);
    try {
      const appdata = await getGcaApplications(
        status,
        token,
        page,
        searchApplicationById,
        limit 
      );
      //.log("Fetched Data:", appdata);

      if (appdata?.success) {
        setApplicationData(appdata.data || []);
        setTotalItems(appdata.totalCount || 0);
      }
    } catch (error) {
      //.error("Error fetching applications:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleSelectChange = (option: Option | null) => {
    setSelectedStatus(option);
    setCurrentPage(1); // Reset to first page when status changes
    fetchApplication(1, searchQuery, limit, option?.value);
  };

  const handleSearch = (value: string) => {
    setSearchQuery(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      fetchApplication(1, value, limit , selectedStatus?.value); 
      setCurrentPage(1); 
    }, 500); 
  };


  useEffect(() => {
    fetchApplication(currentPage, searchQuery, limit, selectedStatus?.value); 
  }, [currentPage, status, limit]);

  return (
    <>
    
      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 d-flex justify-content-end">
          <CommonStatusSelect
              options={status}
              value={selectedStatus} // Use value instead of defaultValue
              onChange={handleSelectChange}
              className="w-25 custom-select me-4"
            />

            <Input
              placeholder="Search Application Id..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 250 }}
              allowClear
            />
          </div>
        </div>
      </div>

    
      <Table
        className="table datanew dataTable no-footer"
        // rowSelection={Selections ? rowSelection : undefined}
        columns={columns}
        rowHoverable={false}
        rowKey={"applicationId"}
        dataSource={applicationData}
        loading={loading}
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right" />,
          prevIcon: <i className="ti ti-chevron-left" />,
          pageSize: limit, 
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          current: currentPage,
          total: totalItems,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total} entries`,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setLimit(pageSize); 
          },
        }}
      />
    </>
  );
};

export default ApplicationTable;
